import { useEffect } from 'react';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { usePreviousState } from '@atlaskit/editor-common/hooks';
import { formatFullWidthAppearance } from './formatFullWidthAppearance';
export var useFireFullWidthEvent = function useFireFullWidthEvent(appearance, dispatchAnalyticsEvent) {
  var previousAppearance = usePreviousState(appearance);
  useEffect(function () {
    if (appearance !== previousAppearance) {
      if (appearance === 'full-width' || previousAppearance === 'full-width') {
        dispatchAnalyticsEvent({
          action: ACTION.CHANGED_FULL_WIDTH_MODE,
          actionSubject: ACTION_SUBJECT.EDITOR,
          eventType: EVENT_TYPE.TRACK,
          attributes: {
            previousMode: formatFullWidthAppearance(previousAppearance),
            newMode: formatFullWidthAppearance(appearance)
          }
        });
      }
    }
  }, [appearance, previousAppearance, dispatchAnalyticsEvent]);
};